/**
 * Lenth unit abbreviations
 */
enum LengthUnit {
	CENTIMETER = 'cm',
	MILLIMETER = 'mm',
	PICA = 'pc',
	POINTS = 'pt',
	INCHES = 'in',
	PIXEL = 'px'
}

export default LengthUnit;